import { coreValues } from "@/data/aboutUs";

export default function CoreValue() {
  return (
    <>
      <div className="relative flex flex-col bg-[#FFF0EE] px-40 py-20 gap-20 overflow-hidden">
        <div className="absolute -right-14 -top-10 w-1/3 h-80 rounded-bl-full rounded-br-xl bg-[#B70100] blur-2xl pointer-events-none" />
        <div className="absolute -left-6 -bottom-6 w-1/4 h-60 rounded-tr-full bg-[#E60000] blur-2xl pointer-events-none" />
        <div className="flex flex-col text-center gap-2" data-aos="fade-up">
          <h1 className="font-bold text-4xl">Built on Core Values</h1>
          <p>
            The principles that shape our approach to teaching, learning, and
            meaningful communication.{" "}
          </p>
        </div>
        <div className="grid grid-cols-4 gap-6 -mt-5">
          {coreValues.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="flex flex-col bg-white/80 p-10 rounded-xl text-center items-center gap-6"
                data-aos="fade-up"
                data-aos-delay={i * 120}
              >
                <div className="bg-[#FFE9E6] rounded-full p-4">
                  <Icon className="text-4xl text-[#B70100]" />
                </div>
                <div className="flex flex-col gap-2">
                  <h1 className="font-semibold text-xl">{item.title}</h1>
                  <p>{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
